import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { base_api_url } from "../../environment.jsx";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const Profile = () => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);


  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

      // Charger les infos depuis localStorage
      useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          const usersession = JSON.parse(storedUser);
          console.log("usersession :", usersession);

          setFormData({
            prenom: usersession.prenom || "",
            nom: usersession.nom || "",
            email: usersession.email || "",
            mot_de_passe: "", // jamais renvoyé par le serveur : vide = inchangé
            ancien_mot_de_passe: "",
          });
        }
      }, []);


      const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    };

    //pour recuprer les elements du formulaire
        const [formData, setFormData] = useState({
            "prenom": "",
            "nom": "",
            "email": "",
            "mot_de_passe": "",
            "ancien_mot_de_passe": ""
        });


     const updateprofile = async (e) => {
      e.preventDefault();

      try {
       const token = JSON.parse(localStorage.getItem("user"))?.access_token;

      const response = await axios.put(`${base_api_url}api/user`, {
        "prenom": formData.prenom,
        "nom": formData.nom,
        "email": formData.email,
        // Envoyé seulement si la personne en saisit un nouveau, avec l'actuel (exigé par le serveur)
        ...(formData.mot_de_passe ? { "mot_de_passe": formData.mot_de_passe, "ancien_mot_de_passe": formData.ancien_mot_de_passe } : {}),
      },
      {
        headers: { 
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}` 
        }
      });
      
      // Handle successful responses (200, 201)
      if (response.status === 200 || response.status === 201) {
        console.log("updateprofile:", response.data);

        // On récupère l'ancien objet user dans le localStorage
        const storedUser = JSON.parse(localStorage.getItem("user")) || {};

        // On fusionne les nouvelles infos avec l'ancien
        // Le mot de passe n'est jamais gardé dans le navigateur
        const sansMotDePasse = { ...storedUser };
        delete sansMotDePasse.mot_de_passe;
        const updatedUser = {
          ...sansMotDePasse,
          prenom: formData.prenom,
          nom: formData.nom,
          email: formData.email,
        };

        // On écrase le localStorage avec les nouvelles données
        localStorage.setItem("user", JSON.stringify(updatedUser));

        // mettre à jour le state formData pour forcer l'affichage
        setFormData({ ...updatedUser, mot_de_passe: "", ancien_mot_de_passe: "" });

        // Show success notification
        MySwal.fire({
          icon: "success",
          // title: "Utilisateur modifié avec succès !",
          text: "Votre profil a été mis à jour avec succès.",
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          customClass: {
            popup: "pixel-toast",
          },
        });

        // Navigate to end order page
        navigate(`/profile`);
      }
      
    } catch (error) {
      console.error("Erreur lors du paiement :", error);
      
//       let errorTitle = "Erreur de validation";
      let errorMessage = "Impossible de valider votre commande. Veuillez réessayer.";
      
      if (error.response) {
        const status = error.response.status;
        const errorData = error.response.data;
        
        switch (status) {

          case 403:
            errorMessage = errorData?.error || "Mot de passe actuel incorrect.";
            break;

          case 400:
//             errorTitle = "Adresse email déjà utilisée";
            errorMessage = errorData?.message || "Veuillez entrer une autre adresse email.";
            break;
            
          case 401:
//             errorTitle = "Session expirée";
            errorMessage = "Votre session a expiré. Vous allez être redirigé vers la page de connexion.";
            break;
            
          case 500:
//             errorTitle = "Erreur du serveur";
            errorMessage = "Une erreur s'est produite sur le serveur. Veuillez actualiser la page.";
            break;
            
          default:
//             errorTitle = `Erreur ${status}`;
            errorMessage = errorData?.message || "Une erreur inattendue s'est produite.";
        }
      } else if (error.request) {
//         errorTitle = "Problème de connexion";
        errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet.";
      }
      
      // Show error notification
      MySwal.fire({
        icon: "error",
        // title: errorTitle,
        text: errorMessage,
        toast: true,
        position: "bottom-end",
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
        customClass: {
          popup: "pixel-toast",
        },
      });
    }
  };


  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Profil</h4>
            <h6>Profil utilisateur</h6>
          </div>
        </div>
        {/* /product list */}
        <div className="card">
          <div className="card-body">
            <div className="profile-set">
              <div className="profile-head"></div>
              <div className="profile-top">
                <div className="profile-content">
                  <div className="profile-contentimg">
                    <ImageWithBasePath
                      src="assets/img/customer/customer5.jpg"
                      alt="img"
                      id="blah"
                      type="file"
                      accept="image/*"
                      className="form-control"
                      name="image_url"
                    />
                    <div className="profileupload">
                      <input type="file" id="imgInp" />
                      <Link to="#">
                        <ImageWithBasePath
                          src="assets/img/icons/edit-set.svg"
                          alt="img"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="profile-contentname">
                    <h2>{formData.prenom} {formData.nom}</h2>
                    <h4>Mettez à jour votre profil.</h4>
                  </div>
                </div>
              </div>
            </div>
            <form onSubmit={updateprofile} className="profile-form">
                <div className="row">
                  <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                      <label className="form-label">Prénom</label>
                      <input
                      type="text"
                      className="form-control"
                      name="prenom"
                      value={formData.prenom}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">Nom</label>
                    <input
                      type="text"
                      className="form-control"
                      name="nom"
                      value={formData.nom}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label>Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">Mot de passe</label>
                    <div className="pass-group">
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        className="pass-input form-control"
                        name="mot_de_passe"
                        value={formData.mot_de_passe}
                        onChange={handleChange}
                        placeholder="Laisser vide pour ne pas le changer"
                        autoComplete="new-password"
                      />
                      <span
                        className={`fas toggle-password ${
                          isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                        }`}
                        onClick={togglePasswordVisibility}
                      ></span>
                    </div>
                  </div>
                </div>
                {formData.mot_de_passe && (
                  <div className="col-lg-6 col-sm-12">
                    <div className="input-blocks">
                      <label className="form-label">Mot de passe actuel</label>
                      <input
                        type="password"
                        className="form-control"
                        name="ancien_mot_de_passe"
                        value={formData.ancien_mot_de_passe}
                        onChange={handleChange}
                        placeholder="Requis pour changer de mot de passe"
                        autoComplete="current-password"
                        required
                      />
                    </div>
                  </div>
                )}
                <div className="col-12 modal-footer-btn">
                  <button type="button" className="btn btn-cancel" style={{ float: "left" }}>
                    Annuler
                  </button>
                  <button type="submit" className="btn btn-submit me-2">
                    Enregistrer
                  </button>
                </div>
              </div>
              </form>  
          </div>
        </div>
        {/* /product list */}
      </div>
    </div>
  );
};

export default Profile;
